import { Box, Tooltip } from "@mui/material";
import { memo, useEffect, useRef, useState } from "react";

// https://mui.com/x/react-data-grid/column-definition/#expand-cell-renderer
// MS確認システム用にカスタマイズされたDataGridのセルコンポーネント
function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}
const GridCellExpand = memo(function GridCellExpand(props) {
  const { value } = props;
  const cellValue = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowTooltip(isCurrentlyOverflown);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  // Escapeキーでツールチップを閉じる（任意）
  useEffect(() => {
    if (!showTooltip) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setShowTooltip(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showTooltip]);

  return (
    <Tooltip
      title={value}
      open={showTooltip}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      placement="top"
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -8],
            },
          },
        ],
      }}
    >
      <Box
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          alignItems: "center",
          lineHeight: "24px",
          width: "100%",
          height: "100%",
          position: "relative",
          display: "flex",
        }}
      >
        <Box
          ref={cellValue}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {value}
        </Box>
      </Box>
    </Tooltip>
  );
});

export default function renderCellExpand(params) {
  return (
    <GridCellExpand
      value={params.value ?? ""}
      width={params.colDef.computedWidth}
      editable={params.colDef.editable}
    />
  );
}
